import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Text,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { AlertModalProps } from './AlertModal.types';

export function AlertModal({
  icon,
  title,
  description,
  textSubmit,
  textCancel,
  useAlertModal,
  loader,
}: AlertModalProps) {
  const { isOpen, onClose, onCancel, onSubmit, submitDangerous } = useAlertModal();
  const cancelRef = useRef(null);
  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={textCancel && onCancel && !textSubmit ? onClose : () => {}}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent
        width={loader ? '480px' : '400px'}
        padding={loader ? '16px 32px 32px 32px' : '24px'}
      >
        <AlertDialogHeader
          display="flex"
          flexDir="column"
          padding="unset"
          alignItems="center"
          textAlign="center"
        >
          <Box mt={loader ? '20px' : 'unset'}>{icon}</Box>
        </AlertDialogHeader>
        <Text
          fontSize="18px"
          fontWeight={loader ? 600 : 500}
          textAlign="center"
          mt={loader ? '40px' : '20px'}
        >
          {title}
        </Text>
        {description && (
          <AlertDialogBody whiteSpace="pre-wrap" padding="unset" marginTop="8px">
            <Text fontSize="14px" color="gray.500" textAlign="center">
              {description}
            </Text>
          </AlertDialogBody>
        )}

        <AlertDialogFooter
          padding="unset"
          mt="24px"
          display={textCancel || textSubmit ? 'flex' : 'none'}
          alignItems="center"
          flex={1}
          gap={3.5}
        >
          {textCancel && (
            <Button
              w={textSubmit ? '50%' : '100%'}
              variant="tertiary"
              fontSize="14px"
              fontWeight={600}
              ref={cancelRef}
              onClick={() => {
                onClose();
                onCancel?.();
              }}
            >
              {textCancel}
            </Button>
          )}
          {textSubmit && (
            <Button
              w={textCancel ? '50%' : '100%'}
              variant={submitDangerous ? 'secondary' : 'quaternary'}
              fontWeight={700}
              onClick={() => {
                onClose();
                onSubmit?.();
              }}
            >
              {textSubmit}
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
